import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

export function useWorkspaceTree(serverId: string, path?: string, depth?: number) {
  const api = useApiClient();

  return useQuery({
    queryKey: ['workspace-tree', serverId, path ?? '', depth ?? 2],
    queryFn: () => api.workspace.tree(serverId, path, depth),
    enabled: !!serverId,
  });
}

export function useWorkspaceFile(serverId: string, path: string | null) {
  const api = useApiClient();

  return useQuery({
    queryKey: ['workspace-file', serverId, path],
    queryFn: () => api.workspace.file(serverId, path!),
    enabled: !!serverId && !!path,
  });
}

export function useWorkspaceGitStatus(serverId: string, path?: string) {
  const api = useApiClient();

  return useQuery({
    queryKey: ['workspace-git-status', serverId, path ?? ''],
    queryFn: () => api.workspace.gitStatus(serverId, path),
    enabled: !!serverId && !!path,
  });
}

export function useWorkspaceGitBranches(serverId: string, path?: string) {
  const api = useApiClient();

  return useQuery({
    queryKey: ['workspace-git-branches', serverId, path ?? ''],
    queryFn: () => api.workspace.gitBranches(serverId, path),
    enabled: !!serverId && !!path,
  });
}
